import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { AuthEnums } from "models/enums";
import { RecurringInvoiceMoreActionProps } from "models/propTypes/invoicePropTypes";
import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { IconDefinitionConstants, RouteConstants } from "utils/constants";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { MoreActions } from "components/common";
import { useNavigate, useLocation } from "react-router-dom";
import { useRecurringInvoiceService } from "serviceHooks";
//#endregion
import { CompanyService } from "services";
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";

const RecurringInvoiceMoreActions: React.FC<RecurringInvoiceMoreActionProps> = (props) => {
  const recurringInvoiceService = useRecurringInvoiceService();
  const location = useLocation();
  const navigate = useNavigate();

  const { invoice, reloadHandler } = props;

  const startInvoice = () => {
    return recurringInvoiceService.start(invoice.id);
  };

  const stopInvoice = () => {
    return recurringInvoiceService.stop(invoice.id);
  };

  const startAction: MoreActionMenuItemType = {
    description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Start),
    icon: IconDefinitionConstants.WBolt,
    onClickHandler: startInvoice,
    onActionSuccess: reloadHandler,
  };

  const stopAction: MoreActionMenuItemType = {
    description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Stop),
    icon: IconDefinitionConstants.WStop,
    onClickHandler: stopInvoice,
    onActionSuccess: reloadHandler,
  };

  const copyInvoiceAction: MoreActionMenuItemType = {
    description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.CopyAction),
    icon: IconDefinitionConstants.WCopy,
    onClickHandler: async () => {
      navigate(
        UrlHelper.formatPath(
          `/Invoice/Create?${RouteConstants.QueryParamStrings.RecurringInvoiceTemplate}=${props.invoice.id}`
        ),
        {
          state: { background: location },
        }
      );
    },
  };

  const getMenuItems = (): MoreActionMenuItemType[] => {
    const status = props.invoice.status;
    const actions: MoreActionMenuItemType[] = [];
    if (!CompanyService.hasRelation(AuthEnums.PersonCompanyRelationType.Auditor)) {
      actions.push(copyInvoiceAction);
      if (status === WintSuperkollAPIModel.RecurringInvoiceState.Created) {
        actions.push(startAction);
      } else if (status === WintSuperkollAPIModel.RecurringInvoiceState.Ongoing) {
        actions.push(stopAction);
      }
    }
    return actions;
  };

  return <MoreActions menuItems={getMenuItems()} />;
};

export default RecurringInvoiceMoreActions;
